import React from 'react';

export enum CicAppKeys {
    TCSM = 'TCSM',
    ORG = 'ORG',
}

export const CicAppContext = React.createContext(CicAppKeys.TCSM);